import {
  RequirementServiceClient,
  ListRequirementRequest,
  ListRequirementDetailRequest,
} from '../proto/marginpb/requirement_grpc_web_pb';
import { stringToProtoDate } from './ConvertService';
import authSvc from './AuthService';
import { auth } from '../lib/auth/Auth';
import { Pagination } from '../proto/utilspb/pagination_pb';

const service = new RequirementServiceClient(window.env.GRPC_ENDPOINT, {}, { ...auth });

const userId = authSvc.getCurrentUser()?.UserId;

export async function listRequirement(param, paging) {
  return new Promise((resolve, reject) => {
    const marginTypes = [];

    if (param.marginType?.length > 0) {
      for (let i = 0; i < param.marginType?.length; i++) {
        marginTypes.push(param.marginType[i].code);
      }
    }

    const marginType = "'" + marginTypes.join("','") + "'";
    let req = new ListRequirementRequest();
    req.setTradeDate(stringToProtoDate(param.tradeDate));
    req.setCorrespondent(param.correspondent);
    req.setMasterAccountNo(param.masterAccountNo);
    req.setAccountName(param.accountName);
    req.setFieldsNotZeroList(param.fieldsNotZero);
    req.setUsrId(userId);
    req.setMarginType(marginType);

    if (paging) {
      let pg = new Pagination();
      pg.setPageNo(paging.pageNo);
      pg.setPageSize(paging.rowsPerPage);
      pg.setSortName(paging.sortName);
      pg.setSortDirection(paging.sortDirection);
      pg.setFilterNamesList(paging.filterNames);
      pg.setFilterValuesList(paging.filterValues);
      req.setPagination(pg);
    }

    service.listRequirement(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function listRequirementDetail(param, paging) {
  return new Promise((resolve, reject) => {
    let req = new ListRequirementDetailRequest();

    req.setTradeDate(stringToProtoDate(param.tradeDate));
    req.setMasterAccountNo(param.masterAccountNo);

    if (paging) {
      let pg = new Pagination();
      pg.setPageNo(paging.pageNo);
      pg.setPageSize(paging.rowsPerPage);
      pg.setSortName(paging.sortName);
      pg.setSortDirection(paging.sortDirection);
      pg.setFilterNamesList(paging.filterNames);
      pg.setFilterValuesList(paging.filterValues);
      req.setPagination(pg);
    }

    service.listRequirementDetail(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}
